module.exports = __webpack_public_path__ + "img/chef2.2fbcab65.svg";